import React from 'react';
import { browserHistory } from 'react-router';
import { menuSelector } from '@arreeba/ristoranti-frontend-lib';
import i18n from '@arreeba/ristoranti-frontend-lib/lib/helpers/i18n';
import Cart from '@arreeba/ristoranti-lib/lib/cart';
import {
  ORDER_TYPE_DELIVERY,
} from '@arreeba/ristoranti-frontend-lib/lib/constants';

import { connect } from '../../util';
import Url from '../../lib/url';
import { urlSelector } from '../../selectors/urlSelectors';
import { orderOvercomeThreshold } from '../../selectors/orderSelectors';
import { orderLocationAddressSelector } from '../../selectors/orderSelectors';

import Spinner from '../../components/spinner';
import ScrollView from '../../components/scrollview';
import {
  MenuItemCategory,
  MenuItem,
  CartButton,
} from '../../components/menu';
import BackButton from '../../components/back-button';
import ButtonsContainer from '../../components/buttonsContainer';
import OrderRecap from '../../components/order-recap';


class Menu extends React.Component {
  componentDidMount() {
    const { restaurantId } = this.props.url;
    const { app, actions, services } = this.props;
    services.order.loadMenu(app.id, restaurantId, actions.order);

    this.renderCategory = this.renderCategory.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.goToCart = this.goToCart.bind(this);
  }

  addToCart(item) {
    this.props.actions.order.addToCart(item);
  }

  goToCart() {
    browserHistory.push(Url.orderCart({ ...this.props.url }));
  }

  renderCategory(name) {
    const items = this.props.menu.itemsGrouped[name];
    return (
      <MenuItemCategory name={name} key={name}>
        {
          items.map(item => <MenuItem
            key={item.id}
            {...item}
            quantity={Cart.itemQuantity(this.props.order.cart, item)}
            onSelect={this.addToCart}
          />)
        }
      </MenuItemCategory>
    );
  }

  render() {
    const { url, order, menu } = this.props;
    const categories = menu.categoriesCollapsed;
    const isDelivery = url.orderType === ORDER_TYPE_DELIVERY;
    const threshold = order.deliveryAreaCustomThreshold || 0;
    const cartTotal = Cart.total(order.cart);
    const buttonDisabled = !this.props.orderOvercomeThreshold;
    if (this.props.isFetching) {
      return (
        <main className="centerChildren">
          <Spinner size="large" />
        </main>
      );
    }
    return (
      <main>
        <header className="menuHeader">
          <OrderRecap
            date={url.orderDate}
            location={this.props.orderAddress}
          />
          <CartButton
            disabled={buttonDisabled}
            total={i18n.formatPrice(cartTotal)}
            text="INVIA ORDINE"
            onClick={this.goToCart}
          />
        </header>
        <ScrollView>
          <div className="menuContainer">
            {
              categories.map(cat => this.renderCategory(cat.name))
            }
          </div>
        </ScrollView>
        <ButtonsContainer>
          <BackButton />
        </ButtonsContainer>
      </main>
    );
  }
}

const mapStateToProps = (state, props) => ({
  ...state,
  isFetching: state.order.menuIsFetching,
  menu: menuSelector(state, props),
  url: urlSelector(state, props),
  orderAddress: orderLocationAddressSelector(state, props).address,
  orderOvercomeThreshold: orderOvercomeThreshold(state, props),
});

export default connect(Menu, { mapStateToProps });



// WEBPACK FOOTER //
// ./src/containers/order/menu.js